import React, { useEffect, useState } from "react";
import {
  Dialog, DialogTitle, DialogContent, DialogActions, Button, Stack, Alert,
  TextField, MenuItem, Box, IconButton, Typography,
} from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import RemoveIcon from "@mui/icons-material/Remove";
import axios from "../../../config/axiosConfig";

const SUCURSALES = ["La Paz", "Cochabamba", "Santa Cruz", "La Paz(El Alto)"];

const EnviarTraspasoDialog = ({ open, onClose, producto, sucursalOrigen, onEnviado }) => {
  const [sucursalDestino, setSucursalDestino] = useState("");
  const [cantidad, setCantidad] = useState(0);
  const [detalle, setDetalle] = useState("");
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState("");

  useEffect(() => {
    if (open) {
      setSucursalDestino("");
      setCantidad(0);
      setDetalle("");
      setError("");
    }
  }, [open]);

  const disponible = Number(producto?.cantidadDisponible || 0);

  const ajustar = (delta) => setCantidad((prev) => Math.min(Math.max(prev + delta, 0), disponible));

  const handleGuardar = async () => {
    setSaving(true);
    setError("");
    try {
      await axios.post("/api/inventario-interno/traspaso", {
        id_producto: producto.id,
        cantidad,
        sucursal_destino: sucursalDestino,
        detalle: detalle.trim(),
      });
      onEnviado();
    } catch (e) {
      setError(e?.response?.data?.message || "Error al enviar el producto.");
    } finally {
      setSaving(false);
    }
  };

  const puedeGuardar = sucursalDestino && cantidad > 0 && detalle.trim() && !saving;

  return (
    <Dialog open={open} onClose={saving ? undefined : onClose} maxWidth="xs" fullWidth>
      <DialogTitle sx={{ fontWeight: 800 }}>
        Enviar {producto?.nombre}
        <Typography variant="body2" color="text.secondary">
          Desde {sucursalOrigen} — disponible: {disponible}
        </Typography>
      </DialogTitle>
      <DialogContent dividers>
        <Stack spacing={1.5} sx={{ mt: 0.5 }}>
          {error && <Alert severity="error">{error}</Alert>}
          <TextField
            select size="small" label="Enviar a" required
            value={sucursalDestino} onChange={(e) => setSucursalDestino(e.target.value)}
          >
            {SUCURSALES.filter((s) => s !== sucursalOrigen).map((s) => (
              <MenuItem key={s} value={s}>{s}</MenuItem>
            ))}
          </TextField>

          <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
            <IconButton size="small" onClick={() => ajustar(-1)} disabled={cantidad <= 0}>
              <RemoveIcon fontSize="small" />
            </IconButton>
            <TextField
              size="small" value={cantidad} inputProps={{ readOnly: true, style: { textAlign: "center" } }}
              sx={{ width: 80 }}
            />
            <IconButton size="small" onClick={() => ajustar(1)} disabled={cantidad >= disponible}>
              <AddIcon fontSize="small" />
            </IconButton>
          </Box>

          <TextField
            size="small" label="Observación" multiline minRows={2} required
            value={detalle} onChange={(e) => setDetalle(e.target.value)}
          />
        </Stack>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} disabled={saving}>Cancelar</Button>
        <Button variant="contained" onClick={handleGuardar} disabled={!puedeGuardar}>
          {saving ? "Enviando..." : "Enviar"}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default EnviarTraspasoDialog;
